module.exports = __webpack_public_path__ + "img/border.2dd6607d.png";